import './SobreNos.css'
import { BsFillTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";

export default function SobreNos(){
    return(
        <div id='sobre' className='containerSobreNos'>
            <div className="quemSomos container">
                <h1>Sobre nós:</h1>
                <h2>Mais de <span className='destaque'>10 anos</span> de experiência em serralheria</h2>
                <p>
                Na LKSME Serviços Gerais, unimos experiência, dedicação e acabamento de alto padrão para desenvolver soluções em serralheria sob medida. Atendemos projetos <span className='destaque'> residenciais, comerciais e industriais</span>, sempre buscando entregar estruturas resistentes, seguras e que atendam às necessidades de cada cliente.

                    Nosso compromisso é oferecer atendimento personalizado, materiais de alta qualidade e excelência em cada etapa do projeto, do planejamento à instalação.

                    Atendemos toda a <span className='destaque'> Região Metropolitana de Belo Horizonte </span>, levando soluções em serralheria com agilidade, profissionalismo e compromisso com a satisfação dos nossos clientes.
                </p>
            </div>
            <div className="contato container">
                <h1>Contato:</h1>
                <ul className='listaContato'>
                    <li>
                        <BsFillTelephoneFill color='#0A5C36' />
                        <p>WhatsApp: 31 99618-8853</p>
                    </li>
                    <li>
                        <MdEmail color='#0A5C36' />
                        <p>Email: sergiomontagemetalica@gmail.com</p>
                    </li>
                    <li>
                        <FaLocationDot color='#0A5C36' />
                        <p>Região Metropolitana de Belo Horizonte</p>
                    </li>
                </ul>
                <div className='areaMapa'>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3747.9682115608994!2d-43.99077512499616!3d-20.05177418136422!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa6bb902822e135%3A0x28a210d636d0ae51!2sSerralheria%20Lksme!5e0!3m2!1spt-BR!2sbr!4v1786240239068!5m2!1spt-BR!2sbr" style={{border:0, allowfullscreen:"", loading:"lazy", referrerpolicy:"strict-origin-when-cross-origin"}}></iframe>
                </div>
            </div>
        </div>
    )
}